export function isAbortError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === "AbortError") {
    return true;
  }
  if (error instanceof Error) {
    if (error.name === "AbortError") return true;
    if (error.message.toLowerCase().includes("signal is aborted")) return true;
  }
  return false;
}
